import React from 'react';
import styled from 'styled-components';
import colors from 'src/constants/styles/colors';
import { BodyText } from 'components/typography/bodyText';

const SCardWrapper = styled.div`
    background: ${colors.gray_10};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    padding: 24px;
    height: 100%;
`;

const SCardHeader = styled.h4<{ $isTitleUpperCase: boolean }>`
    font-size: 20px;
    letter-spacing: 0.02em;
    margin-bottom: 16px;

    font-weight: ${({ $isTitleUpperCase }) => ($isTitleUpperCase ? 500 : 700)};
    line-height: ${({ $isTitleUpperCase }) => ($isTitleUpperCase ? '1.15' : '26px')};
    text-transform: ${({ $isTitleUpperCase }) => ($isTitleUpperCase ? 'uppercase' : 'capitalize')};
`;

const SWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

const SImageWrapper = styled.div`
    display: flex;
`;

const SIcon = styled.img<{ $size: number }>`
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    margin-bottom: 16px;
`;

interface Props {
    header: string;
    description: string;
    iconSrc: string;
    mediaSize?: number;
    isTitleUpperCase?: boolean;
}

const DEFAULT_MEDIA_SIZE = 90;

export const Card = (props: Props) => {
    const size = props.mediaSize ?? DEFAULT_MEDIA_SIZE;
    const isTitleUpperCase = props.isTitleUpperCase ?? false;

    return (
        <SCardWrapper>
            <SImageWrapper>
                <SIcon src={props.iconSrc} alt="" aria-hidden="true" $size={size} />
            </SImageWrapper>
            <SWrapper>
                <SCardHeader $isTitleUpperCase={isTitleUpperCase}>{props.header}</SCardHeader>
                <BodyText>{props.description}</BodyText>
            </SWrapper>
        </SCardWrapper>
    );
};
